import "@/App.css";
import "@/dashboard.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/AuthContext";
import { CallsProvider } from "@/CallsContext";
import { GoalsProvider } from "@/GoalsContext";
import { PeriodProvider } from "@/PeriodContext";
import { AdminRoute, ProtectedRoute } from "@/ProtectedRoute";
import AppLayout from "@/layouts/AppLayout";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import RefundsPage from "@/pages/RefundsPage";
import DashboardPage from "@/pages/DashboardPage";
import HistoryPage from "@/pages/HistoryPage";
import GoalsPage from "@/pages/GoalsPage";
import CompaniesPage from "@/pages/CompaniesPage";
import PayRatesPage from "@/pages/PayRatesPage";
import EducationPage from "@/pages/EducationPage";
import ComingSoonPage from "@/pages/ComingSoonPage";
import BillingPage from "@/pages/BillingPage";
import SettingsPage from "@/pages/SettingsPage";
import InstallPage from "@/pages/InstallPage";
import AdminPage from "@/pages/AdminPage";
import AdminEmailPreviewsPage from "@/pages/AdminEmailPreviewsPage";
import AdminCrmBackfillPage from "@/pages/AdminCrmBackfillPage";
import AdminLifecycleDryRunPage from "@/pages/AdminLifecycleDryRunPage";
import AdminManualAccessPage from "@/pages/AdminManualAccessPage";

function AppShell() {
  return (
    <PeriodProvider>
      <CallsProvider>
        <GoalsProvider>
          <AppLayout />
        </GoalsProvider>
      </CallsProvider>
    </PeriodProvider>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/refunds" element={<RefundsPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/install" element={<InstallPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/goals" element={<GoalsPage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/pay-rates" element={<PayRatesPage />} />
              <Route path="/education" element={<EducationPage />} />
              <Route
                path="/ai"
                element={
                  <ComingSoonPage
                    title="AI"
                    copy="Insights, summaries, and coaching on your call history are on the way. Your data already syncs — this workspace will use it next."
                  />
                }
              />
              <Route path="/billing" element={<BillingPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="/admin" element={<AdminRoute />}>
              <Route index element={<AdminPage />} />
              <Route path="email-previews" element={<AdminEmailPreviewsPage />} />
              <Route path="email-previews/:emailType" element={<AdminEmailPreviewsPage />} />
              <Route path="crm-backfill" element={<AdminCrmBackfillPage />} />
              <Route path="manual-access" element={<AdminManualAccessPage />} />
              <Route path="lifecycle-dry-run" element={<AdminLifecycleDryRunPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
